import { registerLocaleData } from '@angular/common';
import { Injectable, Injector, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { InjectorProvider } from '@shared/providers';
import { getPreferredLanguage, importAngularLocale } from '@shared/utils';
import { CheckForUpdateService } from './check-for-update.service';
import { FeatureFlagService } from './feature-flag.service';

@Injectable({
  providedIn: 'root'
})
export class AppInitializeService {
  private readonly translateService = inject(TranslateService);
  private readonly updateService = inject(CheckForUpdateService);
  private readonly featureFlagService = inject(FeatureFlagService);


  private readonly allowedLanguages = ['en', 'de', 'fr', 'nl'];

  constructor() {
    InjectorProvider.injector = inject(Injector);
  }

  async init(): Promise<boolean> {
    const language = getPreferredLanguage();

	this.updateService.init();
    this.featureFlagService.init();

    this.translateService.addLangs(this.allowedLanguages);
    this.translateService.setDefaultLang(language);

    const locale = await importAngularLocale(language);
    registerLocaleData(locale.default);

    return true;
  }
}
